import axios from 'axios'
import LGSdk from './index'

/**
 * 获取多语言标识配置
 * @returns
 */
export const getLGConfigs = (isAcc = false) => {
  const timestamp = new Date().getTime()
  const domain = isAcc ? LGSdk.LGAliOssAccBaseURL : LGSdk.LGAliOssBaseURL
  return axios.get(`${domain}${LGSdk.LGOssPathEnum.LG_CONFIG}${LGSdk.LGFileNameEnum.LG_CONFIG}?t=${timestamp}`)
}

/**
 * 获取平台多语言文本配置
 * @returns
 */
export const getLGLabelsByPlatform = (platform, isAcc = false) => {
  const timestamp = new Date().getTime()
  const path = LGSdk.LGOssPathEnum[platform]
  const domain = isAcc ? LGSdk.LGAliOssAccBaseURL : LGSdk.LGAliOssBaseURL
  return axios.get(`${domain}${path}${LGSdk.LGFileNameEnum.LG_LABEL}?t=${timestamp}`)
}
